import { sprintf } from 'sprintf-js';

import AppLocale from '../lang';
import LocalStorage from './localStorage';

export const defaultLocale = 'aze';
export const locale = LocalStorage.getItem('lang') || defaultLocale;

const messages = AppLocale[locale];

export const getTranslation = translationId => {
    return messages[translationId];
};

export const formatMessage = (message, values) => {
    return sprintf(message, values);
};
